var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImcDelgadezWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 52",
    style: {
      enableBackground: "new 0 0 19 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#105742;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,8.9c2.4,0,4.4-2,4.4-4.4c0-2.5-2-4.4-4.4-4.4C7,0,5.1,2,5.1,4.4C5.1,6.9,7,8.9,9.5,8.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,10.1l-4.3,0l-4.3,0c-3.6,0-5,2.9-5,5.1v13c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4V15.9h0.7 c0.7,0,2.5-0.2,2.9,1.4c0.5,2.1,0.2,6.5,0,7.2c-0.6,1.7-2.2,2.2-2.2,3.6v22c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8V30.4h1.4h1.4 v19.8c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8v-22c0-1.4-1.6-1.9-2.2-3.6c-0.2-0.7-0.5-5.1,0-7.2c0.4-1.7,2.2-1.4,2.9-1.4h0.7v12.3 c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4v-13C18.7,13,17.3,10.1,13.7,10.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImcDelgadezWhite);
export default __webpack_public_path__ + "static/media/IMC_Delgadez_white.b9a399d1.svg";
export { ForwardRef as ReactComponent };